import { useEditorStore } from '../store/editorStore';
import { useLayerStore } from '../store/layerStore';
import type MapEngine from '@/map-core';

/**
 * 图层显隐管理器
 *
 * 层级：controller（"业务怎么做"）
 *
 * 职责：
 * 1. 统一处理图层的显隐切换（WMS / 动态图层）
 * 2. 切换后重新高亮当前选中面（避免被隐藏图层覆盖）
 *
 * 不知道 BMapGL，只通过 MapEngine API 操作图层
 */
export class LayerVisibilityManager {
  constructor(
    private getMap: () => MapEngine,
    private highlightMap: (data: any) => void
  ) {}

  /**
   * 切换图层显隐
   * @param layerId 图层 ID
   * @param wmsLayerIds 所有 WMS 图层 ID 集合，用于判断是 WMS 还是动态图层
   */
  toggleLayerVisible(
    layerId: string,
    wmsLayerIds: Set<string>,
    hiddenDynamicLayerIds: string[],
    hiddenWmsLayerIds: string[],
    toggleDynamicLayer: (id: string) => void,
    toggleWmsLayer: (id: string) => void
  ) {
    const hiddenLayerIds = [...hiddenDynamicLayerIds, ...hiddenWmsLayerIds];
    const curSelect = !hiddenLayerIds.includes(layerId);

    if (wmsLayerIds.has(layerId)) {
      toggleWmsLayer(layerId);
    } else {
      toggleDynamicLayer(layerId);
    }

    this.getMap().changeLayerVisible(layerId, !curSelect);

    const curData = useEditorStore.getState().session.activePolygonData;
    if (curData) {
      this.highlightMap(curData);
    }
  }
}
